module.exports = __webpack_public_path__ + "static/media/meeting.ec66e0f8.jpg";